// @ts-nocheck
import { ReactReduxContext } from 'react-redux'

import { IS_DEVELOPMENT } from 'shared/consts'
import getComponentDisplayName from 'shared/utils/getComponentDisplayName'

const withStore = Component => {
  const WithStore = props => (
    <ReactReduxContext.Consumer>
      {({ store }) => <Component {...props} store={store} />}
    </ReactReduxContext.Consumer>
  )

  if (IS_DEVELOPMENT) {
    WithStore.displayName = getComponentDisplayName(Component)
  }

  return WithStore
}

export default withStore
